import i18n from "../../translations";
import reduxStore from "../../redux/store";
import * as utils from "../../helpers/utils";
import moment from "moment";
import { DRIVER_OBJECT } from "application/motor/helpers/models";


const getReduxStateData = () => {
  return reduxStore.getState().motor;
};

export const getCustomerDetailsRequest = (data) => {

  let phoneNumber = "";

  if (!getReduxStateData()?.isleadGeneratation) {

    if (data.mobile.slice(0, 4) === "+966") {

      phoneNumber = data.mobile;
    } else if (data.mobile.slice(0, 3) === "966") {

      phoneNumber = "+" + data.mob;
    } else if (data.mobile.slice(0, 1) === "0") {

      phoneNumber = data.mobile.substring(1);
      phoneNumber = "+966" + data.mobile
    } else {

      phoneNumber = "+966" + data.mobile
    }
  } else {
    phoneNumber = "+966500000000"
  }

  
  const request = {
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
    idNumber: data.nationalId,
    dateOfBirth: data.mob ? `${data.mob.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}-${data.yob}` : data.yob,
    mobileNumber: phoneNumber,
    applicationType: "RHSP",
    otp: getReduxStateData().otp
  };
  data.channelDetails && (request.channelDetails = data.channelDetails);

  return request
};

export const getCustomerDetailsResponse = (response) => {

  const { customerInformation, idNumber, resultCode, resultMessage } = response.data;
  if (resultCode !== "S") return { resultCode, resultMessage };
  const resData = customerInformation.policyHolder[0];
  if (!resData.idNumber) {
    resData["idNumber"] = idNumber;
  }
  return resData;
};

export const getDriverDetailsRequest = (data) => {
  if (utils.isSaudi(data.nationalId)) {
    const gregDob = getReduxStateData().customerDetails.gregDob;
    return {
      productCode: "PRMotorImtiazeCO",
      languageCode: utils.getOneLetterLanguageCode(i18n.language),
      idNumber: data.nationalId,
      dob:gregDob.slice(3, 5)+'-'+gregDob.slice(6, 10) 
    };
  }
  const request = {
    productCode: "PRMotorImtiazeCO",
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
    idNumber: data.nationalId,
    dob: data.mob+'-'+data.yob,
  };
  data.channelDetails && (request.channelDetails = data.channelDetails);
  return request;
};


export const getDriverDetailsRequestPolicy = (data) => {
  if (utils.isSaudi(data.nationalId)) {
    // const gregDob = "18-07-1980";
    return {
      productCode: "PRMotorImtiazeCO",
      languageCode: utils.getOneLetterLanguageCode(i18n.language),
      idNumber: data.nationalId,
      dob: data.mob+'-'+data.yob,
    };
  }
  const request = {
    productCode: "PRMotorImtiazeCO",
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
    idNumber: data.nationalId,
    dob: data.mob+'-'+data.yob,
  };
  data.channelDetails && (request.channelDetails = data.channelDetails);
  return request;
};

export const getDriverDetailsResponse = (response) => {
  const { driverDetails, resultCode, resultMessage } = response.data;
  if (resultCode === "V") {
    return { resultCode, resultMessage };
  }
  return driverDetails.vehicleDriverDetailsArray[0];
};

export const getNationalityRequest = (data) => {
  return {
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
  };
};

export const getVehicleDetailsRequest = (data) => {
  ////     // console.log(getReduxStateData().personalFormDetails);
  const request = {
    transferOwnerIDNumber: data.registrationType === "t" ? data.transferId : "",
    yearOfManufacture: data.vehicleType === "custom" ? data.yom.getFullYear().toString() : "",
    plateType: "11",
    sequenceNumber: (data.vehicleType === "registration" ? data.number : "") || data.serialNumber,
    productCode: "MotorImtiazeTP",
    transferFlag: data.registrationType === "t" ? "Y" : "N",
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
    customCardNumber: data.vehicleType === "custom" ? data.number : "",
    idNumber: getReduxStateData().personalFormDetails.nationalId,
  };
  data.channelDetails && (request.channelDetails = data.channelDetails);
  return request;
};

export const getVehicleDetailsResponse = (response) => {
  if (
    response &&
    response.value &&
    response.value.data &&
    response.value.data.resultCode &&
    response.value.data.resultCode !== "S"
  ) {
    return { resultCode: response.value.data.resultCode, resultMessage: response.value.data.resultMessage };
  }
  return response.value.data.vehicleDetails.vehicleDetailsArray[0];
};

export const getMotorModelsByMake = (makeCode) => {
  return {
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
    makeCode,
    productCode: "PRMotorImtiazeCO",
  };
};

export const customerDetailsPrepareForGetProposal = (customer) => {
  const {
    zipCode,
    preferredContactMethodName,
    nationalityName,
    maritalStatusCode,
    officeWaselPostalCode,
    nationalityCode,
    engLastName,
    araLastName,
    homeWaselEngStreetName,
    homeWaselEngDistrictName,
    araMidName,
    araFirstName,
    maritalStatusName,
    engMidName,
    officeWaselAraStreetName,
    homeWaselRegionName,
    officeWaselRegionName,
    cityCode,
    engFullName,
    occupationName,
    regionName,
    educationCode,
    bankName,
    officeWaselCityName,
    officeWaselEngStreetName,
    homeWaselCityName,
    regionCode,
    cityName,
    officeWaselEngDistrictName,
    educationName,
    engFirstName,
    homeWaselAraStreetName,
    araFullName,
    bankCode,
    homeWaselAraDistrictName,
    officeWaselRegionCode,
    preferredLanguageName,
    twitterName,
    preferredContactMethodCode,
    genderName,
    officeWaselCityCode,
    occupationCode,
    homeWaselPostalCode,
    officeWaselAraDistrictName,
    preferredLanguageCode,
    ...rest
  } = customer;
  rest["childUnderSixteen"] = "0";
  return {
    policyHolder: [rest],
  };
};

const vehicleDriverPrepareForGetProposal = (drivers) => {
  return drivers.map((driver) => {
    return {
      officeSelfUnitNumber: "",
      gregDob: "01-01-2000",
      educationCode: "GRD",
      maritalStatusCode: "1",
      officeWaselPostalCode: "24351",
      nationalityCode: "7",
      roadConvictionsCode: "NIL",
      medicalConditionsCode: "1",
      homeWaselRegionCode: "1",
      officeWaselAdditionalNumber: "7267",
      driverRelationCode: "NOR",
      childUnderSixteen: "0",
      homeSelfUnitNumber: "",
      officeWaselBuildingNumber: "3773",
      officeWaselRegionCode: "1",
      licenseTypeCode: "1",
      mobile: "+966582639666",
      isPolicyHolder: "Y",
      officeWaselCityCode: "38",
      driverType: "",
      homeWaselBuildingNumber: "3773",
      genderCode: "1",
      occupationCode: "26",
      claimsIn5YearsCode: "0",
      driverUsagePercentageCode: "100",
      homeWaselAdditionalNumber: "7267",
      homeWaselCityCode: "38",
      homeWaselPostalCode: "24351",
      accidentsIn5YearsCode: "0",
      IDNO: "2445547918",
    };
  });
};

export const vehicleObjectPrepareForGetProposal = (vehicle, drivers) => {
  //
  const vehicleDriverDetails = vehicleDriverPrepareForGetProposal(drivers);
  const { plateType, makeName, modelName, ncdValue, ...rest } = vehicle;
  delete rest.colorName;
  delete rest.amount;
  delete rest.dedAmount;
  delete rest.model;
  delete rest.title;
  const carDetails = {
    ...rest,
    vehicleValue: String(vehicle.vehicleValue),
    yearOfManufacture: String(vehicle.yearOfManufacture),
    plateTypeCode: "1", // Unknown error happen!
    agencyRepairRequired: "N", // Repair Type
    usageTypeCode: "PRIVATE",
    majorDrivingRegionCode: "1",
    majorDrivingCityCode: "38",
    vehicleTransferFlag: "N",
    parkingLocationCode: "MOTOR_AR_PARKING",
    transmissionCode: "1",
    mileagePerYearCode: "2",
    currentMileage: "100000",
    parkingLocationName: "",
    transmissionName: "Automatic",
    deductibleForUnifiedForm: null,
    milagePerYearName: "Between 10000 and 25000.",
    colorCode: "11",
    vehicleDriverDetails: {
      vehicleDriverDetailsArray: vehicleDriverDetails,
    },
  };
  if (vehicle?.selectedFeatures?.length) {
    Object.assign(carDetails, {
      selectedFeatures: {
        selectedFeatures: vehicle?.selectedFeatures ?? [],
      },
    });
  }
  return carDetails;
};

export const getInceptionDate = (date) => {
  return moment(date, "YYYY-MM-DD").isAfter(moment())
    ? moment(date, "YYYY-MM-DD").format("DD-MM-YYYY")
    : moment().add(1, "d").format("DD-MM-YYYY");
};

export const getProposalForRequest = ({ customerDetails, vehicle, promocode }, productCode) => {
  //
  try {
    let drivers = [...getReduxStateData().drivers];
    if (drivers[0]?.isPolicyHolder || !drivers[0]?.isPolicyHolder) {
      drivers[0].isPolicyHolder = "Y";
    }
    const tempVehicle = { ...vehicle };
    delete tempVehicle.colorName;
    delete tempVehicle.plateType;
    delete tempVehicle.ncdValue;
    delete tempVehicle.modelName;
    delete tempVehicle.makeName;
    let proposalObject = {
      languageCode: utils.getOneLetterLanguageCode(i18n.language),
      demandRequestType: "C",
      endorsementType: "PSL",
      idNumber: customerDetails?.idNumber || "2376225229",
      productCode: productCode || "ALL",
      promotionalFactors: null,
      specialSchemeCode: "STANDARD",
      upgradeDetails: {
        cancelDate: null,
        policyNumber: null,
      },
      customerDetails: {
        policyHolder: [{ ...customerDetails }],
      },
      vehicleDetails: {
        vehicleDetailsArray: [tempVehicle],
      },
      tmx: getReduxStateData().tmx,
    };
    //
    if (Boolean(promocode.length)) {
      proposalObject.promotionalFactors = {
        promotionalFactorArray: [
          {
            promotionalCode: promocode,
          },
        ],
      };
    }

    //
    proposalObject.vehicleDetails.vehicleDetailsArray.forEach((vehicle) => {
      delete vehicle.selectedFeatures;
      vehicle.vehicleValue && (vehicle.vehicleValue = parseInt(vehicle.vehicleValue).toString());
      vehicle.deductibleForUnifiedForm = null;
      vehicle.vehicleDriverDetails.vehicleDriverDetailsArray = [];
      drivers.forEach((driver) => {
        const fullDriver = { ...DRIVER_OBJECT, ...driver };
        if (fullDriver.isPolicyHolder === "Y" || fullDriver?.vehicle === tempVehicle?.chassisNumber) {
          vehicle.vehicleDriverDetails.vehicleDriverDetailsArray.push(fullDriver);
        }
        //
        delete fullDriver.vehicle;
        delete fullDriver.nationalId;
        delete fullDriver.yob;
        delete fullDriver.mob;

        // delete fullDriver.childUnderSixteenCode;
        // fullDriver.childUnderSixteen = fullDriver.childUnderSixteen || "0";
      });
    });
    //
    delete proposalObject.vehicleDetails.vehicleDetailsArray[0].ncdValue;
    delete proposalObject.customerDetails.policyHolder[0].idNumber;
    delete proposalObject.vehicleDetails.vehicleDetailsArray[0].weight;
    delete proposalObject.vehicleDetails.vehicleDetailsArray[0].cylinders;
    delete proposalObject.vehicleDetails.vehicleDetailsArray[0].vehicleLoad;
    proposalObject.customerDetails.policyHolder[0].childUnderSixteen = proposalObject.customerDetails.policyHolder[0].childUnderSixteen || "0";
    proposalObject.customerDetails.policyHolder[0].nationalityName = proposalObject.customerDetails.policyHolder[0].nationalityName || "JAMAICA";

    return JSON.parse(JSON.stringify(proposalObject));
  } catch (e) {
    console.log("request####-22", e)
  }
};

export const getProposalResponse = (data) => {
  const proposals = [...data.value.data.proposals.proposalsArray];
  if (!proposals || !proposals.length) {
    return null;
  }
  // return proposals.map((ele) => ele.productSubCode === "Mecha_MI" ? getMechanicalObject(ele) : getProductObject(ele));
  return proposals;
};

export const createQuotationRequest = (data) => {

  //
  const vehicleDetailsArray = JSON.parse(JSON.stringify(getReduxStateData().vehicles));
  if (data?.productCode === "Mecha_MI") {
    vehicleDetailsArray.forEach((item) => {
      item.mbiPlan = data?.mbiPlan || "C";
      item.currentMileage = data?.mbiData?.currentMileage ? data.mbiData.currentMileage : null;
      item.priorPolicyNumber = data?.mbiData?.priorPolicyNumber
        ? data.mbiData.priorPolicyNumber
        : null;
      item.priorPolicyExpiryDate = data?.mbiData?.priorPolicyExpiryDate
        ? data.mbiData.priorPolicyExpiryDate
        : null;
      item.vehicleDriverDetails.vehicleDriverDetailsArray = [];
    });
  } else {
    vehicleDetailsArray.forEach((item) => {
      item.mbiPlan = "";
      item.currentMileage = null;
      item.priorPolicyNumber = null;
      item.priorPolicyExpiryDate = null;
      item.vehicleDriverDetails.vehicleDriverDetailsArray = [];
      if (data?.productCode === "MotorImtiazeTP") {
        item.deductible = null;
      } 
      else if (data?.productCode === "PRMotorImtiazeSP") {
        item.deductible = item?.deductibleSP?.toString() || "1250";
      }
      delete item.deductibleSP

    });
  }

  const request = {
    requiredInceptionDate: getReduxStateData().leadInceptionDate|| getInceptionDate(data.requiredInceptionDate),
    consumerTrackingID: null,
    customerDetails: customerDetailsPrepareForGetProposal({
      ...getReduxStateData().customerDetails,
    }),
    demandRequestType: "C",
    endorsementCode: "NEW",
    endorsementType: "PSL",
    genericCustomParameter: null,
    idNumber: getReduxStateData().personalFormDetails.nationalId,
    languageCode: utils.getOneLetterLanguageCode(i18n.language),
    productCode: data.productCode,
    promotionalFactors: {
      promotionalFactorArray: [
        {
          promotionalCode: data.promocode,
        },
      ],
    },
    requestGeneratedTime: null,
    specialSchemeCode: "STANDARD",
    upgradeDetails: {
      cancelDate: null,
      policyNumber: null,
    },
    vehicleDetails: {
      vehicleDetailsArray,
    },
    // channelDetails: {
    //   applicationCategory: "RH",
    //   branchCode: "85",
    //   sourceCode: "550541",
    //   applicationType: "RHSP",
    //   userName: "EBUSUSER",
    //   channelCode: "85",
    // },
    proposalNumber: data.ProposalNumber,
    tmx: getReduxStateData().tmx,
  };
  //
  request.vehicleDetails.vehicleDetailsArray.map((vehicle) => {
    vehicle.vehicleValue && (vehicle.vehicleValue = parseInt(vehicle.vehicleValue).toString());

    delete vehicle.colorName;
    delete vehicle.plateType;
    delete vehicle.ncdValue;
    delete vehicle.modelName;
    delete vehicle.makeName;
    delete vehicle.weight;
    delete vehicle.cylinders;
    delete vehicle.vehicleLoad;
    getReduxStateData().drivers.forEach((element, i) => {
      if (element?.vehicle === vehicle.chassisNumber || i == 0) {
        vehicle.vehicleDriverDetails.vehicleDriverDetailsArray.push({
          ...DRIVER_OBJECT,
          ...element,
          genderCode: element?.genderCode || "1",
        });
      }
      //
      element.driverRelationCode = element.driverRelationCode || "NOR";
      //
      element.childUnderSixteenCode = element.childUnderSixteenCode || "0";
    });
    vehicle.vehicleDriverDetails.vehicleDriverDetailsArray[0].driverType = "MD";

    vehicle.vehicleDriverDetails.vehicleDriverDetailsArray.forEach((element) => {
      delete element.vehicle;
      delete element.nationalId;
      delete element.yob;
      delete element.mob;

      element.hijDob = null;
      element.mobile = utils.prepareMobileNumber(element?.mobile?.trim());
      //
      // delete element.childUnderSixteenCode;
      // element.childUnderSixteen = element.childUnderSixteen || "0";
    });

    let TEMP = [];
    const features = [];
    if (vehicle?.selectedFeatures?.length) {
      TEMP = [...vehicle?.selectedFeatures];
      if (TEMP?.length) {
        TEMP.forEach((feature) => {
          feature.featureItems.featureItemsArray.forEach((f) => {
            features.push({
              featureCode: f.featurecode,
            });
          });
        });
      }
      delete vehicle.selectedFeatures;
      if (Boolean(features.length)) {
        vehicle["selectedFeatures"] = { selectedFeatures: features };
      }
    } else {
      delete vehicle.selectedFeatures;
    }
    // if(TEMP?.length){
    //   TEMP.forEach(feature => {
    //     feature.featureItems.featureItemsArray.forEach(f => {
    //       features.selectedFeatures.push(
    //         {
    //           featureCode: f.featurecode
    //         }
    //       )
    //     })
    //   });
    // }
    // delete vehicle.selectedFeatures;
    // vehicle.selectedFeatures = {...features}
  });
  // 

  delete request.customerDetails.policyHolder[0].idNumber;
  getReduxStateData()?.personalFormDetails?.mobile && (
    request.customerDetails.policyHolder[0].mobile = (getReduxStateData().personalFormDetails.prefixMobile + getReduxStateData().personalFormDetails.mobile).trim()
  );
  //
  request.customerDetails.policyHolder[0].childUnderSixteen = request.customerDetails?.policyHolder[0]?.childUnderSixteen || "0";
  request.customerDetails?.policyHolder[0]?.genderCode ||
    (request.customerDetails.policyHolder[0].genderCode = "1");
  request.customerDetails.policyHolder[0].nationalityName = getReduxStateData()?.customerDetails?.nationalityName || "JAMAICA";
  request.customerDetails.policyHolder[0].nationalityCode = getReduxStateData()?.customerDetails?.nationalityCode || "196";
  //
  request.customerDetails?.policyHolder[0]?.childUnderSixteen && (request.customerDetails.policyHolder[0].childUnderSixteen = "0");
  request.driveFlag = getReduxStateData()?.driverRegistered?.isDriverSelected && (data?.productCode === 'PRMotorImtiazeSP' || data?.productCode === 'PRMotorImtiazeCO')? 'Y':'Y';
  return request;
};

export const createQuotationResponse = (response) => {
  //
  return response;
};
